import {
  AdobeDataLayerPageViewPayload,
  AdobeDataLayerSchedulingPayload,
  AdobeDataLayerSearchPayload,
  DataLayerObject,
  Provider
} from '@/types'

export function addAdobeDataLayerPageView(
  payload?: AdobeDataLayerPageViewPayload
): void {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push({
        event: "page-view",
        web: {
            page: {
                name: payload?.name
            },
            site: {
                name: "locator"
            }
        },
        user: {
            clientId: payload?.clientID, // From %Client ID% data element
            group: {
                identifier: payload?.groupId, // From %Active Group ID% data element
                list: []
            }
        },
        environment: {
            sys: "UAT",
            url: window.location.href,
            host: window.location.hostname,
            embedded: false
        },
        search: {
            filter: {},
            provider: {
                name: {
                    added: ""
                }
            },
            zipCode: "",
            results: [],
        },
        technical: {
            dataLayerVersion: "2.0.0"
        }
    }) as DataLayerObject
}

export function trackAdobeDataLayerProviderSearchSuccess(
 event: string,
  payload?: AdobeDataLayerSearchPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        search: {
            provider: {
                success: 1,
                Shown: 1,
                name: {
                    added: ""
                }
            },
            filter: {
                network: payload?.network,
                language: payload?.language,
                speciality: payload?.speciality,
                gender: payload?.gender,
                acceptingNewPatients: payload?.acceptingNewPatients,
                hours: payload?.hours,
                services: payload?.services,
                products: payload?.products,
                brands: payload?.brands,
            },
            zipCode: payload?.searchedZipCode,
            results: formatProviderResults(payload?.results,payload?.currentPage),
        }
    }) as DataLayerObject
}

export function trackAdobeDataLayerProviderSearchFailure(
 event: string,
  payload?: AdobeDataLayerSearchPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        search: {
            provider: {
                failure: 1,
                name: {
                    added: ""
                }
            },
            filter: {
                network: payload?.network,
                language: payload?.language,
                speciality: payload?.speciality,
                gender: payload?.gender,
                acceptingNewPatients: payload?.acceptingNewPatients,
                hours: payload?.hours,
                services: payload?.services,
                products: payload?.products,
                brands: payload?.brands,
            },
            zipCode: payload?.searchedZipCode,
            results: payload?.results,
        }
    }) as DataLayerObject
}

export function trackAdobeDataLayerProviderNameSearchFailure(
 event: string,
  payload?: AdobeDataLayerSearchPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        search: {
            provider: {
                failure: 1,
                name: {
                    failure: 1,
                    added: "Nonexistent Provider Name"
                }
            },
            filter: {
                network: payload?.network,
                language: payload?.language,
                speciality: payload?.speciality,
                gender: payload?.gender,
                acceptingNewPatients: payload?.acceptingNewPatients,
                hours: payload?.hours,
                services: payload?.services,
                products: payload?.products,
                brands: payload?.brands,
            },
            zipCode: payload?.searchedZipCode,
            results: payload?.results,
        }
    }) as DataLayerObject
}
export function trackAdobeDataLayerProviderSearchPaginationApplied(
 event: string,
  payload?: AdobeDataLayerSearchPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        action: {
            pagination: 1
        },
        search: {
            provider: {
                Shown: 1,
                name: {
                    added: ""
                }
            },
            filter: {
                network: payload?.network,
                language: payload?.language,
                speciality: payload?.speciality,
                gender: payload?.gender,
                acceptingNewPatients: payload?.acceptingNewPatients,
                hours: payload?.hours,
                services: payload?.services,
                products: payload?.products,
                brands: payload?.brands,
            },
            zipCode: payload?.searchedZipCode,
            results: formatProviderResults(payload?.results,payload?.currentPage),
        }
    }) as DataLayerObject
}
export function trackAdobeDataLayerProviderSearchNoProvidersMatchFilters(
 event: string,
  payload?: AdobeDataLayerSearchPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        action: {
            pagination: 1
        },
        search: {
            provider: {
                failure: 1,
                name: {
                    added: ""
                }
            },
            filterNoMatch: 1,
            filter: {
                network: payload?.network,
                language: payload?.language,
                speciality: payload?.speciality,
                gender: payload?.gender,
                acceptingNewPatients: payload?.acceptingNewPatients,
                hours: payload?.hours,
                services: payload?.services,
                products: payload?.products,
                brands: payload?.brands,
            },
            zipCode: payload?.searchedZipCode,
            results: payload?.results,
        }
    }) as DataLayerObject
}

export function trackAdobeDataLayerProviderSearchAdditionalFiltersApplied(
 event: string,
  payload?: AdobeDataLayerSearchPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        action: {
            filtersApplied: 1
        },
        search: {
            provider: {
                Shown: 1,
                name: {
                    added: ""
                }
            },
            filter: {
                network: payload?.network,
                language: payload?.language,
                speciality: payload?.speciality,
                gender: payload?.gender,
                acceptingNewPatients: payload?.acceptingNewPatients,
                hours: payload?.hours,
                services: payload?.services,
                products: payload?.products,
                brands: payload?.brands,
            },
            zipCode: payload?.searchedZipCode,
            results: formatProviderResults(payload?.results,payload?.currentPage),
        }
    }) as DataLayerObject
}
export function trackAdobeDataLayerSchedulingStep(
  event: string,
  payload?: AdobeDataLayerSchedulingPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        scheduling: {
            tab: {
                step1: {
                    start: 1
                }
            },
            providerLocationId: payload?.locationId,
            bandDescription: payload?.bandDescription,
            tieredProvider: payload?.tieredLocation === true ? 'Y' : 'N',
            bandId: payload?.bandId
        },
        search: {
            zipCode: payload?.searchedZipCode ?
            payload?.searchedZipCode: 'My Location'
        }
    }) as DataLayerObject
}

export function trackAdobeDataLayerSchedulingExamInfoStep(
  event: string,
  payload?: AdobeDataLayerSchedulingPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        scheduling: {
            tab: {
                step2: {
                    examInfoFinished: 1
                }
            },
            providerLocationId: payload?.locationId,
            bandDescription: payload?.bandDescription,
            tieredProvider: payload?.tieredLocation === true ? 'Y' : 'N',
            bandId: payload?.bandId
        },
        search: {
            zipCode: payload?.searchedZipCode ?
            payload?.searchedZipCode: 'My Location'
        }
    }) as DataLayerObject
}

export function trackAdobeDataLayerSchedulingDateFinishedStep(
  event: string,
  payload?: AdobeDataLayerSchedulingPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        scheduling: {
            tab: {
                step3: {
                    scheduleDateFinished: 1
                }
            },
            providerLocationId: payload?.locationId,
            bandDescription: payload?.bandDescription,
            tieredProvider: payload?.tieredLocation === true ? 'Y' : 'N',
            bandId: payload?.bandId
        },
        search: {
            zipCode: payload?.searchedZipCode ?
            payload?.searchedZipCode: 'My Location'
        }
    }) as DataLayerObject
}

export function trackAdobeDataLayerSchedulingStepCompleted(
  event: string,
  payload?: AdobeDataLayerSchedulingPayload
): void {
    window.adobeDataLayer.push({
        event,
        eventInfo: {
            linkName: event,
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        scheduling: {
            tab: {
                step4: {
                    completed: 1
                }
            },
            providerLocationId: payload?.locationId,
            bandDescription: payload?.bandDescription,
            tieredProvider: payload?.tieredLocation === true ? 'Y' : 'N',
            bandId: payload?.bandId
        },
        search: {
            zipCode: payload?.searchedZipCode ?
            payload?.searchedZipCode: 'My Location'
        }
    }) as DataLayerObject
}

export function trackAdobeDataLayerExternalScheduleLinkClick(
  externalScheduleLink: string,
  payload?: AdobeDataLayerSchedulingPayload
): void {
    window.adobeDataLayer.push({
        event: "schedule-link-clicked",
        eventInfo: {
            linkName: "schedule-link-clicked",
            linkType: "other"
        },
        user: {
            clientId: payload?.clientID || '',
            group: {
                identifier: payload?.groupId || ''
            }
        },
        scheduling: {
            scheduleLinkClicked: 1,
            linkUrl: externalScheduleLink,
            providerLocationId: payload?.locationId,
            bandDescription: payload?.bandDescription,
            tieredProvider: payload?.tieredLocation === true ? 'Y' : 'N',
            bandId: payload?.bandId,
            storeNumber: payload?.externalStoreNumber
        },
        search: {
            zipCode: payload?.searchedZipCode ?
            payload?.searchedZipCode: 'My Location'
        }
    }) as DataLayerObject
}

function formatProviderResults(results: Provider[], currentPage:number){
    const formattedResults: string[] = results.map(
    (result: Provider, i): string => {
      const hasSchedulingLink =
        result.locationUrl !== null && result.locationUrl !== undefined
          ? 'Y'
          : 'N'
      const tier = result.tieredLocation === true ? 'Y' : 'N'
      const resultPosition =
        currentPage === 1 ? i + 1 : (currentPage - 1) * 10 + (i + 1)
      return `${result.bandId}:${resultPosition}:${hasSchedulingLink}:${tier}:${result.locationId}`
    }
  )
  return formattedResults
}
